module.exports = __webpack_public_path__ + "static/media/bruschettatomatorocksalt.5a18c947.jpg";